import { GetLocalStorage } from '../misc/UseLocalStorage';

export const checkAndRedirectToProfile = (isAuth?: boolean): void => {
  const statusPengisian = GetLocalStorage({ name: 'status_pengisian' });
  
  if (isAuth !== false && statusPengisian !== 'true') {
    window.location.href = '/profile';
  }
};
